'use strict';

/**
 * Search
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.Search = T.createModule({

	_selectors: {
		button: '[data-js-m-search__loadmore]',
		items: '[data-js-m-search__items]',
		buttonInside: '.a-button'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		this.page = 1;
		this.$button = this.$ctx.find(this._selectors.button);
		this.$buttonInside = this.$button.find(this._selectors.buttonInside);
		this.$items = this.$ctx.find(this._selectors.items);

		this.$button.click(this.$onButtonClick.bind(this));

		resolve();
	},


	/**
  * Disables the button and triggers loading of furter content.
  *
  * @param {Object} event The event.
  * @returns {void}
     */
	$onButtonClick: function $onButtonClick(event) {
		event.preventDefault();
		this.$button.attr('disbaled', 'disabled');
		this.loadMore();
	},


	/**
  * Triggers an AJAX request to load more results.
  *
  * @returns {void}
  */
	loadMore: function loadMore() {
		var url = this.$buttonInside.attr('href');
		$.ajax({
			cache: false,
			url: url,
			method: 'GET',
			dataType: 'json'
		}).done(this.getSuccess.bind(this));
	},


	/**
  * Handles a successful AJAX request, by adding the content to the search results.
  *
  * @param {Object} response The response in JSON format.
  * @returns {void}
     */
	getSuccess: function getSuccess(response) {
		var _this = this;

		if (response.items && response.items.length > 0) {
			response.items.map(function (item) {
				return _this.$items.append(item.data);
			});
		} else {
			this.$button.hide();
		}
	}
});